// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "apikey".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "apikey" table (1:1 with a DB row, on the wire). */
export const apikeyAtomSchema = z.object({
    id: z.string(),
    name: z.string().nullable(),
    start: z.string().nullable(),
    prefix: z.string().nullable(),
    key: z.string(),
    userId: z.string(),
    refillInterval: z.number().nullable(),
    refillAmount: z.number().nullable(),
    lastRefillAt: z.string().datetime().nullable(),
    enabled: z.boolean(),
    rateLimitEnabled: z.boolean(),
    rateLimitTimeWindow: z.number().nullable(),
    rateLimitMax: z.number().nullable(),
    requestCount: z.number(),
    remaining: z.number().nullable(),
    lastRequest: z.string().datetime().nullable(),
    expiresAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    permissions: z.string().nullable(),
    metadata: z.unknown().nullable(),
});
//# sourceMappingURL=apikey.js.map